import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GlobalTTSManager } from '@/utils/globalTTSManager';
import { AudioManager } from '@/utils/audioUtils';
import { AzureAudioManager } from '@/utils/azureAudioManager';
import { logger } from '@/utils/logger';

export const useTTSCleanupOnRoute = () => {
  const location = useLocation();

  useEffect(() => {
    logger.debug('Route changed to:', location.pathname, '- Stopping all TTS');
    
    // Stop all TTS systems
    GlobalTTSManager.getInstance().stopAllTTS();
    AudioManager.getInstance().stop();
    AzureAudioManager.getInstance().stopAll();
    
    // Force stop web speech API if running
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
  }, [location.pathname]);
};